module.exports = __webpack_public_path__ + "static/media/watermark.df0bdf9f.png";